import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/citations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { bookId } = Route.useParams();
  return <CitationBrowse publicationId={bookId} />;
}
